
import {apiUrl} from '../constants';
import axios from 'axios';
const path = `/MacAddress`;

var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':'Bearer ' +localStorage.getItem('token'),'Content-Type':'application/json'}
})

export default class SoporteMacsToolsAPI{
    /**
     * Obtiene listado relacionado al PDV  
     * @returns 
     */
    static getAllPdv(caffenioId){
        
        return request.get(`${path}/${caffenioId}`);
    }

    /**
     * Consulta detalle de punto de venta 
     * @param {*} id 
     * @returns 
     */
    static addMac(data){
        return request.post(`${path}`, data);
    }

   
   
}